function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 24.8034C13.7561 24.8034 13.5498 24.719 13.381 24.5502L4.60312 16.0818C4.50934 16.0068 4.38039 15.8849 4.21628 15.7161C4.05216 15.5472 3.79192 15.2401 3.43555 14.7947C3.07918 14.3492 2.76033 13.892 2.47898 13.4231C2.19764 12.9542 1.94678 12.3868 1.72639 11.721C1.50601 11.0551 1.39581 10.408 1.39581 9.77972C1.39581 7.71653 1.99132 6.1035 3.18234 4.94062C4.37336 3.77773 6.01922 3.19629 8.11991 3.19629C8.70135 3.19629 9.29452 3.2971 9.8994 3.49873C10.5043 3.70036 11.067 3.97233 11.5875 4.31463C12.1079 4.65693 12.5558 4.97813 12.9309 5.27823C13.306 5.57833 13.6624 5.89718 14 6.23479C14.3376 5.89718 14.694 5.57833 15.0691 5.27823C15.4442 4.97813 15.892 4.65693 16.4125 4.31463C16.933 3.97233 17.4957 3.70036 18.1006 3.49873C18.7054 3.2971 19.2986 3.19629 19.88 3.19629C21.9807 3.19629 23.6266 3.77773 24.8176 4.94062C26.0086 6.1035 26.6041 7.71653 26.6041 9.77972C26.6041 11.8523 25.5304 13.9623 23.3828 16.1099L14.6189 24.5502C14.4501 24.719 14.2438 24.8034 14 24.8034Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearth);
export default __webpack_public_path__ + "static/media/hearth.1edc91ed934113f7d9cb6eac26b3ad2f.svg";
export { ForwardRef as ReactComponent };